import React from 'react';
import Box from '@mui/material/Box';
import { iconHues } from '../../theme';

/**
 * An icon on a soft tinted circle (the portal's way of adding colour that
 * means something: one hue per kind, kept everywhere that kind appears).
 *
 *   <IconCircle icon={<PaymentsOutlinedIcon />} hue="success" />
 *
 * hue: 'accent' | 'info' | 'success' | 'danger' | 'amber' | 'neutral'.
 */
export default function IconCircle({ icon, hue = 'accent', size = 32, sx }) {
  const tone = iconHues[hue] || iconHues.accent;
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: tone.bg,
        color: tone.fg,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
        '& .MuiSvgIcon-root': { fontSize: Math.round(size * 0.58) },
        ...(sx || {}),
      }}
    >
      {icon}
    </Box>
  );
}
